import { CSSProperties } from "react";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    body3: CSSProperties;
    paragraph: CSSProperties;
    captionBold: CSSProperties;
    labelRegular: CSSProperties;
    labelBold: CSSProperties;
    capsRank: CSSProperties;
    h5Int: CSSProperties;
    subtitleAlt: CSSProperties;
  }

  interface TypographyVariantsOptions {
    body3?: CSSProperties;
    paragraph?: CSSProperties;
    captionBold?: CSSProperties;
    labelRegular?: CSSProperties;
    labelBold?: CSSProperties;
    capsRank?: CSSProperties;
    h5Int?: CSSProperties;
    subtitleAlt?: CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    body3: true;
    paragraph: true;
    captionBold: true;
    labelRegular: true;
    labelBold: true;
    capsRank: true;
    h5Int: true;
    subtitleAlt: true;
  }
}

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({
  sm,
  md,
  lg,
}: {
  sm: number;
  md: number;
  lg: number;
}) {
  return {
    "@media (min-width:600px)": {
      fontSize: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(lg),
    },
  };
}

const typography = {
  fontFamily: "Ubuntu,sans-serif",
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
} as const;

export default typography;
